<template>
  <div class="povrsine">
      <div class="glava">
        Slika v glavi
      </div>
      <div class="kmg">
        <div class="nosilec"><div>{{ pridelovalec.ime }}</div><div>Priimek in ime</div></div>
        <div class="naslov"><div>{{pridelovalec.naslov}} {{pridelovalec.postnastevilka}} - {{pridelovalec.posta}}</div><div>Naslov</div></div>
        <div class="kontrolnast"><div>{{pridelovalec.kontrolnastevilka}}</div><div>Kontrolna številka</div></div> 
      </div>
      <div class="info">
          <h2> ZAPISNIK POVRŠINE <sub>( v skladu z Uredbo Sveta (ES) št. 834/2007, Uredbo Komisije (ES) št. 889/2008 in Pravilnikom o ekološki pridelavi in predelavi kmetijskih pridelkov oz. živil)</sub></h2>
      </div>
      <div class="gerki">
    
    <table id="gerki">
        <tr>
            <th>GERK_PID</th>
            <th class="raba">Opis</th>
            <th>Kultura</th>
            <th>Površina (ha)</th>
            <th>Dejanska povr. (ha)</th>
            <th>Domače ime</th>
            <th>Status</th>
            <th>Preg. P</th>

        </tr>
  <tr v-for="gerk in gerki" :key="gerk.gerkpid">
    <td>{{ gerk.gerkpid}}</td>
    <td>{{ gerk.raba}}</td>
    <td>{{ gerk.kulture}}</td>
    <td>{{ gerk.povrsina}}</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr class="vsota"><td colspan="2"></td><td>Skupaj:</td><td>{{vsotaPovrsin}}</td><td colspan="4"></td></tr>
</table>

      </div>
    <div class="podpis">
         <div class="podpisstranke">Podpis</div>
        <div class="datumzig">Datum in žig</div>
        <div class="ko">Certifikacijski organ</div> 
    </div>
      <div class="noga"></div>

</div>
</template>
<script>
export default {
    props: ["gerki","vsotaPovrsin","pridelovalec"]
    }

</script>
<style>
.povrsine {
      margin: 15mm 45mm 30mm 45mm; 

}
.povrsine h2 {
      color:black;


}
.povrsine sub {
    font-size:smaller;
}


.glava{
    height:40mm;
    display:flex;
    align-items:center;
    justify-content:center;
    border:1px solid black;
}
.kmg{
    margin-top:15mm;
    display:flex;

}
.kmg>div{
    border:1px solid black;
}
.kmg div {
    text-align:center;
}
.kmg div div:nth-child(1) {
    font-size:1.2em;
    font-weight:bold;
}
.kmg div div:nth-child(2) {
    font-size:0.8em;
}
.kmg .nosilec {
    flex-grow:2;
}
.kmg .naslov {
    flex-grow:3;
}
.kmg .kontrolnast {
    flex-grow:1;
}


.info {
    margin-top:8mm;
}

.gerki {
     margin-top:8mm;   
}

.povrsine table{
    width:100%;
}
.povrsine table,.povrsine  th,.povrsine  td {
    border:1px solid black;
    border-collapse:collapse;

}
.povrsine td, .povrsine th {
    padding:0 1mm;
}
.povrsine .vsota {
    font-weight:bold;
}

.podpis{
    margin-top:8mm;
    display:flex;

}
.podpis>div{
    border:1px solid black;
    padding-bottom:20mm;
}
.podpis div {
    text-align:center;
}
.podpis div div:nth-child(1) {
    font-size:1.2em;
    font-weight:bold;
}
.podpis div div:nth-child(2) {
    font-size:0.8em;
}
.podpis .podpisstranke {
    flex-grow:2;
}
.podpis .datumzig {
    flex-grow:3;
}
.podpis .ko {
    flex-grow:1;
}

@media print {
      .povrsine{
        margin:0;
      }
    body{
        
        width: 21cm;
        height: 29.7cm;
        margin: 30mm 45mm 30mm 45mm; 
        /* change the margins as you want them to be. */
   } 
}
</style>
